import MuiPaper from '@mui/material/Paper';
import { styled } from '@mui/system';

const FFPaper = styled(MuiPaper)(({ theme }) => ({
    padding: '10px 10px 10px 10px',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 20,
    border: '1px solid rgb(2, 117, 216, 0.5);',
    boxShadow: '0px 0px 20px #00000014',
    backgroundColor: 'white',
  }));

export default FFPaper;
